import Routes from "./Routes";

export { default as history } from "./history";

export default Routes;
